<template>
    <div class="message-modal">
        <div v-if="reply.status && reply.status == 'sending'" class="send-loader"><span></span></div>
        <!-- <div class="send-loader"><span></span></div> -->
        <transition name="bodyloader">
            <div v-if="loading" class="message-modal-loader">
                <svg viewBox="0 0 399 399">
                <path d="M340.566,58.431A199.5,199.5,0,0,0,58.432,340.57,199.5,199.5,0,1,0,340.566,58.431ZM327.742,71.255A180.177,180.177,0,0,1,380.862,199.5H339.754c0-77.338-62.918-140.256-140.255-140.256-4.589,0-9.125.229-13.6,0.661V18.635q6.756-.5,13.6-0.5A180.177,180.177,0,0,1,327.742,71.255ZM199.5,321.619A122.119,122.119,0,1,1,321.617,199.5,122.256,122.256,0,0,1,199.5,321.619Z"/>
                </svg>
            </div>
        </transition>
        <div ref="message_container" class="message-modal-body">
            <div class="message-modal-body-inner">
                <div v-if="page_loading" class="messages-loader">loading more...</div>
                <transition-group name="item-fade">
                    <message-item v-for="(item, index) in list" :key="index" :data="item"></message-item>
                </transition-group>
            </div>
        </div>
        <div class="message-modal-footer">
            <reply></reply>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Reply from './Reply'
import MessageItem from './MessageItem'

export default {
    components: {
        Reply,
        MessageItem
    },
    data() {
        return {
            text: '',
        }
    },
    computed: {
        ...mapState('messageList', ['list', 'admin', 'loading', 'page_loading', 'last_page', 'reply'])
    },
    mounted() {
        this.$refs.message_container.addEventListener('scroll', () => {
            if (this.$refs.message_container.scrollTop == 0) {
                this.getMoreMessage()
            }
        }, false)
    },
    watch: {
        list() {
            this.$nextTick(() => this.$refs.message_container.scrollTop = this.$refs.message_container.scrollHeight)
        },
        last_page(val, oldVal) {
            if (val && oldVal && val != oldVal) {
                let v = this.$refs.message_container.scrollHeight
                this.$nextTick(() => this.$refs.message_container.scrollTop = this.$refs.message_container.scrollHeight - v - 100)
            }
        }
    },
    methods: {
        ...mapMutations('messageList', ['showMessagePageLoading']),
        getMoreMessage() {
            if ( !this.last_page ) return
            this.$remote.$emit('getConversation', { conversation_id: this.admin.conversation_id, is_pagination: 1, last_id: this.last_page })
            this.showMessagePageLoading()
        }
    }
}
</script>

<style lang="scss" scoped>
.message-modal { position: absolute; top: 75px; bottom: 0; left: 0; right: 0; display: flex; flex-direction: column; background: #fff;
    .send-loader {position: absolute; bottom: 65px; right: 50px; display: flex; animation: sending .6s infinite alternate ease-in-out; z-index: 2;
        &::before, &::after, span { content: ''; display: block; width: 16px; height: 16px; border-radius: 50%; background: #ddd;}
        span {margin: 0 3px; }
    }
    &-body { flex: 1 1 auto; overflow-y: auto; position: relative;
        &-inner { padding: 30px 35px 40px;}
    }
    &-loader {position: absolute; top: 0; left: 0; bottom: 0; right: 0; width: 100%; height: calc(100% - 55px); display: flex; justify-content: center; align-items: center;
        background: rgb(255, 255, 255); z-index: 2147483001;
        svg {fill: #ccc; width: 28px; height: 28px; margin-bottom: 50px;
            animation: loaderCyc 1s infinite linear;
        }
    }
    &-footer { position: relative; }
}
.item-fade-enter-active, .item-fade-leave-active {
  transition: all .4s;
}
.item-fade-enter, .item-fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0; transform: translateY(10px);
}

.bodyloader-enter-active, .bodyloader-leave-active {
  transition: all .35s;
}
.bodyloader-enter, .bodyloader-leave-to {
  opacity: 0;
}

@keyframes loaderCyc {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
@keyframes sending {
    0% { opacity: 0;}
    100% { opacity: 1;}
}
</style>


// WEBPACK FOOTER //
// src/components/MessageModal.vue